import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import { START_SURVEY_EXECUTION } from 'src/graphql/survey/mutation';

export default () => {
  const [startSurveyExecution] = useMutation(START_SURVEY_EXECUTION);

  return useCallback((params) => startSurveyExecution(
    { variables: params }), []);
}
